<style scoped>
    #option-excel-input{
        display: none;
    }
    .mis-table td, .mis-table th{
        padding: 1px;
    }
    .mis-table th{
        padding: 8px 1px;
    }
    .ivu-chart-circle {
        vertical-align: middle;
    }
    .circle-text{
        display: inline-block;
        transform: scale(0.8,0.8);
    }
    .pop-tip-content{
        min-height: 35px;
    }
    .select-customer{
        margin-top: 5px;
    }
</style>
<template>
  <div>
    <Tabs
      value="option"
      type="card"
    >
      <TabPane
        label="期权信息"
        name="option"
      >
        <div>
          <label
            class="ivu-btn ivu-btn-warning ivu-btn-small"
            for="option-excel-input"
          >
            <Icon type="android-upload" />
            导入数据
          </label>
          <Button
            size="small"
            icon="md-refresh"
            @click="getOptions"
          >
            刷新数据
          </Button>
          <Button
            size="small"
            type="primary"
            icon="md-add"
            @click="editOption(new_option)"
          >
            添加期权
          </Button>
        </div>

        <div class="line">
          <input
            id="option-excel-input"
            ref="importInput"
            type="file"
            @focus="importFocus"
            @change="importInvoice"
          >
          <div
            v-show="import_processing"
            class="line"
          >
            <Progress
              :percent="import_percent"
              status="active"
            />
          </div>
        </div>
        <div class="line list-container">
          <table class="mis-table text-center">
            <tr>
              <th>姓名</th>
              <th>期权起始日期</th>
              <th>期权数量</th>
              <th>摊薄比例</th>
              <th>摊薄/回购后数量</th>
              <th>成熟比例</th>
              <th>成熟数量</th>
              <th>
                <Tooltip
                  transfer
                  placement="top"
                >
                  <span>行权价格</span>
                  <Icon type="ios-help" />
                  <span slot="content">
                    买入价
                  </span>
                </Tooltip>
              </th>
              <th>
                <Tooltip
                  transfer
                  placement="top"
                >
                  <span>公司估值</span>
                  <Icon type="ios-help" />
                  <span slot="content">
                    卖出价
                  </span>
                </Tooltip>
              </th>
              <th>期权总价值</th>
              <th>已成熟总价值</th>
              <th>操作</th>
            </tr>
            <tr
              v-for="(option,index) in options"
              :key="option.id"
            >
              <td>{{ option.account }}</td>
              <td>{{ option.start_date }}</td>
              <td>{{ option.option_count }}</td>
              <td>
                <i-circle
                  :size="32"
                  :percent="option.dilute_scale * 100"
                >
                  <span class="circle-text">{{ option.dilute_scale * 100 }}%</span>
                </i-circle>
              </td>
              <td>{{ option.dilute_count }}</td>
              <td>
                <i-circle
                  :size="32"
                  :percent="option.ripe_scale * 100"
                >
                  <span class="circle-text">{{ option.ripe_scale * 100 }}%</span>
                </i-circle>
              </td>
              <td>{{ option.ripe_count }}</td>
              <td>￥{{ option.buying_price }}</td>
              <td>￥{{ option.selling_price }}</td>
              <td>￥{{ option.option_total_price }}</td>
              <td>￥{{ option.ripe_total_price }}</td>
              <td>
                <Button
                  size="small"
                  shape="circle"
                  icon="md-create"
                  @click="editOption(option)"
                />
                <Poptip
                  transfer
                  placement="left"
                  confirm
                  title="您确认删除这条信息吗？"
                  @on-ok="delOption(option, index)"
                >
                  <Button
                    size="small"
                    shape="circle"
                    :loading="isDeleting(option)"
                    icon="md-close"
                  />
                </Poptip>
              </td>
            </tr>
          </table>
          <Backdrop v-show="getting_option" />
        </div>
      </TabPane>
      <TabPane
        label="期权订单"
        name="option-order"
      >
        <div class="line">
          <span>年份:</span>
          <DatePicker
            type="year"
            :value="order_params.year"
            style="width: 120px"
            @on-change="setExportYear"
          />
          <Button @click="getOptionOrders">
            获取订单
          </Button>
          <Button @click="exportOrders">
            导出订单
          </Button>
        </div>
        <div class="line">
          <Table
            border
            stripe
            :loading="order_loading"
            :columns="order_columns"
            :data="orders"
            size="small"
          />
        </div>
      </TabPane>
      <!--<TabPane label="模拟计算" name="option-calc">
                <OptionTaxCalc></OptionTaxCalc>
            </TabPane>-->
    </Tabs>

    <Modal
      v-model="edit_option_config.modal"
      title="添加/编辑期权"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_option_config.loading"
      @on-ok="editOptionOk"
    >
      <Form
        :model="edit_option"
        label-position="right"
        :label-width="90"
      >
        <FormItem label="员工姓名">
          <Poptip
            placement="bottom"
            width="300"
          >
            <Button long>
              {{ edit_option.account || '请设置员工' }}
            </Button>
            <div
              slot="content"
              class="pop-tip-content"
            >
              <i-input
                v-model="search_customer_text"
                placeholder="请搜索员工..."
                @on-enter="searchCustomer"
              >
                <span slot="prepend">搜索</span>
                <Button
                  slot="append"
                  @click="searchCustomer"
                >
                  确定
                </Button>
              </i-input>
              <div class="select-customer-container">
                <div
                  v-for="customer in search_customer_result"
                  :key="customer.id"
                  class="select-customer"
                >
                  <Button
                    size="small"
                    long
                    :disabled="customer.id === edit_option.customer_id"
                    @click="setOptionCustomer(customer)"
                  >
                    <span>{{ customer.account }} - </span>
                    <span>{{ customer.uid }} - </span>
                    <span>{{ customer.team }}</span>
                  </Button>
                </div>
              </div>
            </div>
          </Poptip>
        </FormItem>
        <FormItem label="起始日期">
          <DatePicker
            type="date"
            :value="edit_option.start_date"
            placeholder="选择期权起始日期"
            @on-change="setStartDate"
          />
        </FormItem>
        <FormItem label="期权数量">
          <i-input v-model="edit_option.option_count" />
        </FormItem>
        <FormItem label="摊薄比例">
          <i-input v-model="edit_option.dilute_scale" />
        </FormItem>
        <FormItem label="摊薄/回购后数量">
          <i-input v-model="edit_option.dilute_count" />
        </FormItem>
        <FormItem label="成熟比例">
          <i-input v-model="edit_option.ripe_scale" />
        </FormItem>
        <FormItem label="成熟数量">
          <i-input v-model="edit_option.ripe_count" />
        </FormItem>
        <FormItem label="行权价格">
          <i-input v-model="edit_option.buying_price" />
        </FormItem>
        <FormItem label="公司估值">
          <i-input v-model="edit_option.selling_price" />
        </FormItem>
        <FormItem label="期权总价值">
          <i-input v-model="edit_option.option_total_price" />
        </FormItem>
        <FormItem label="已成熟总价值">
          <i-input v-model="edit_option.ripe_total_price" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script route="/option/management">
  import Util from '../../libs/util';
  import OptionTaxCalc from './components/option_tax_clac';
  export default {
    /* router_info_start */
    router_info: '/option/management',
    /* router_info_end */

    components: { OptionTaxCalc },
    data() {
      return {
        import_processing: false,
        import_percent: 0,
        getting_sms: false,
        sms_timeout: 0,
        getting_option: false,
        sms_code: '',
        options: [],
        option_columns: [
          {
            title: '姓名',
            align: 'center',
            fixed: 'left',
            width: 100,
            key: 'account'
          },
          {
            title: '期权成熟起始日',
            align: 'center',
            width: 120,
            key: 'start_date'
          },
          {
            title: '期权数量',
            align: 'center',
            width: 100,
            key: 'option_count'
          },
          {
            title: '摊薄比例',
            align: 'center',
            width: 80,
            key: 'dilute_scale',
            render: (h, params) => {
              const row = params.row;
              if (row.dilute_scale.indexOf('%') > -1) {
                return h('div', row.dilute_scale);
              } else {
                const scale = math.eval(`${row.dilute_scale} * 100`);
                return h('div', `${scale}%`);
              }
            }
          },
          {
            title: '摊薄/回购后期权数量',
            align: 'center',
            width: 120,
            key: 'dilute_count'
          },
          {
            title: '成熟比例',
            align: 'center',
            width: 80,
            key: 'ripe_scale',
            render: (h, params) => {
              const row = params.row;
              if (row.ripe_scale.indexOf('%') > -1) {
                return h('div', row.ripe_scale);
              } else {
                const scale = math.eval(`${row.ripe_scale} * 100`);
                return h('div', `${scale}%`);
              }
            }
          },
          {
            title: '已成熟期权数量',
            width: 120,
            align: 'center',
            key: 'ripe_count'
          },
          {
            title: '行权价格(买入价)',
            align: 'center',
            width: 120,
            key: 'buying_price',
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.buying_price))
            }
          },
          {
            title: '每股估值(卖出价)',
            align: 'center',
            width: 120,
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.selling_price));
            }
          },
          {
            title: '期权总价值',
            align: 'center',
            width: 100,
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.option_total_price));
            }
          },
          {
            title: '已成熟期权总价值',
            align: 'center',
            width: 140,
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.ripe_total_price));
            }
          }
        ],
        new_option: {
          customer_id: 0,
          account: '',
          mobile: '',
          start_date: '',
          option_count: 0,
          dilute_scale: 0,
          dilute_count: 0,
          ripe_scale: 0,
          ripe_count: 0,
          buying_price: 0,
          selling_price: 0,
          option_total_price: 0,
          ripe_total_price: 0,
        },
        edit_option: {},
        edit_option_config: {
          modal: false,
          loading: true
        },
        deleting_option_id: 0,
        no_data_text: '输入[验证码], 点击查看按钮加载期权数据',
        getting_order: false,
        order_columns: [
          {
            title: '订单年份',
            align: 'center',
            width: 70,
            fixed: 'left',
            key: 'year'
          },
          {
            title: '姓名',
            align: 'center',
            width: 80,
            fixed: 'left',
            key: 'account'
          },
          {
            title: '卖出数量',
            align: 'center',
            width: 120,
            key: 'selling_count'
          },
          {
            title: '卖出总价值',
            align: 'center',
            width: 120,
            key: 'total_price',
            render: (h, params) => {
              return h('div', `￥${Util.formatPrice(params.row.total_price)}`);
            }
          },
          {
            title: '卖出后实得',
            align: 'center',
            width: 120,
            key: 'net_price',
            render: (h, params) => {
              return h('div', `￥${Util.formatPrice(params.row.net_price)}`);
            }
          },
          {
            title: '期权个税',
            align: 'center',
            width: 120,
            key: 'option_tax',
            render: (h, params) => {
              return h('div', `￥${Util.formatPrice(params.row.option_tax)}`);
            }
          },
          {
            title: '计税基础',
            align: 'center',
            width: 120,
            key: 'tax_base',
            render: (h, params) => {
              return h('div', `￥${Util.formatPrice(params.row.tax_base)}`);
            }
          },
          {
            title: '个税总计',
            align: 'center',
            width: 120,
            key: 'total_tax',
            render: (h, params) => {
              return h('div', `￥${Util.formatPrice(params.row.total_tax)}`);
            }
          },
          {
            title: '年终奖',
            align: 'center',
            width: 120,
            key: 'annual_bonus',
            render: (h, params) => {
              return h('div', `￥${Util.formatPrice(params.row.annual_bonus)}`);
            }
          },
          {
            title: '年终奖个税',
            align: 'center',
            width: 120,
            key: 'bonus_tax',
            render: (h, params) => {
              return h('div', `￥${Util.formatPrice(params.row.bonus_tax)}`);
            }
          },
          {
            title: '订单明细',
            align: 'center',
            width: 135,
            fixed: 'right',
            key: 'desc',
            render: (h, params) => {
              return h('div', {
                domProps: {
                  innerHTML: params.row.desc || ''
                }
              })
            }
          }
        ],
        orders: [],
        order_loading: false,
        search_customer_text: '',
        search_customer_result: [],
        order_params: {
          year: new Date().getFullYear().toString()
        }
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      sms_btn_text() {
        if (!this.getting_sms && this.sms_timeout === 0) {
          return '获取验证码';
        }
        if (this.sms_timeout > 0) {
          return `${this.sms_timeout} S`;
        }
        return '获取中...';
      },
    },
    created() {
      this.getOptions();
      this.getOptionOrders();
    },
    mounted() {
      //
    },
    methods: {
      resetInvoiceInput() {
        this.$refs.importInput.value = '';
      },
      importFocus() {
        this.resetInvoiceInput();
      },
      importInvoice() {
        const file_path = this.$refs.importInput.value;
        const path_arr = file_path.split('.');
        const extname = path_arr[path_arr.length - 1].toLowerCase();
        if (['xlsx'].indexOf(extname) === -1) {
          this.$Modal.warning({
            title: '提示',
            content: '请上传Excel文件(后缀名应为xlsx)'
          });
          return;
        }

        const file = this.$refs.importInput.files[0];
        const formData = new FormData();
        formData.append('datafile', file);

        this.import_processing = true;
        Util.ajax({
          url: Util.api.import_option,
          method: 'post',
          data: formData,
          timeout: 120000,
          onUploadProgress: (e) => {
            const percent = e.loaded / e.total * 100;
            this.import_percent = percent < 0.1 ? 0.1 : percent;
          },
        }).then(function(response) {
          return response.data;
        }).then((data) => {
          this.import_processing = false;
          this.resetInvoiceInput();
          console.log(data);
          if (data.code === 1) {
            this.$Modal.success({
              title: '提示',
              content: '导入成功!'
            });
            this.getOptions();
          } else {
            this.$Modal.error({
              title: '提示',
              content: data.msg
            });
          }
        }).catch((e) => {
          this.import_processing = false;
          this.resetInvoiceInput();
          this.$Message.error(`上传失败!: ${e}`);
        });
      },
      getSmsCode() {
        Util.ajax.post(Util.api.option_sms_admin_code, {
          customer_id: this.cur_customer.id,
          mobile: this.cur_customer.mobile
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.sms_timeout = 120;
            this.sms_timer = setInterval(() => {
              this.sms_timeout--;
              if (this.sms_timeout <= 0) {
                clearInterval(this.sms_timer);
              }
            }, 1000);
            this.$Message.success('发送短信成功!');
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.error({title: '提示', content: e.message});
        });
      },
      getOptions() {
        this.getting_option = true;
        Util.ajax.get(Util.api.get_options, {
          params: {
            //
          },
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.getting_option = false;
          if (data.code === 1) {
            this.options = [];
            data.options.forEach((option) => {
              this.options.push(option);
            });
            if (this.options.length === 0) {
              this.$Modal.warning({title: '提示', content: '没有查找到期权数据, 如有疑问, 请联系开发!'});
            }
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.getting_option = false;
          this.$Modal.error({title: '提示', content: e.message});
        });
      },
      searchCustomer() {
        Util.ajax.get(Util.api.query_customer_with_team_company, {
          params: {
            search: this.search_customer_text
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.search_customer_result = [];
          if (res.code === 1) {
            const data = res.data;
            data.forEach((customer) => {
              this.search_customer_result.push(customer);
            })
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      setOptionCustomer(customer) {
        this.edit_option.customer_id = customer.id;
        this.edit_option.account = customer.account;
        document.body.click();
      },
      setStartDate(date) {
        console.log(date);
        this.edit_option.start_date = date;
      },
      editOption(option) {
        this.edit_option = Util.clone(option);
        this.edit_option_config.modal = true;
      },
      checkValid() {
        let err_msg = '';
        if (!this.edit_option.customer_id) {
          err_msg += '<p>请选择[员工]</p>';
        }
        if (!this.edit_option.start_date) {
          err_msg += '<p>请选择[起始日期]</p>';
        }
        if (!this.edit_option.option_count) {
          err_msg += '<p>请填写[期权数量]</p>';
        } else if (!Util.isNumber(this.edit_option.option_count)) {
          err_msg += '<p>请填写正确的[期权数量]</p>';
        }
        if (!this.edit_option.dilute_scale) {
          err_msg += '<p>请填写[摊薄比例]</p>';
        } else if (!Util.isNumber(this.edit_option.dilute_scale)) {
          err_msg += '<p>请以小数填写[摊薄比例], 如: 0.5, 0.75等</p>';
        }
        if (!this.edit_option.dilute_count) {
          err_msg += '<p>请填写[摊薄/回购后数量]</p>';
        } else if (!Util.isNumber(this.edit_option.dilute_count)) {
          err_msg += '<p>请填写正确的[摊薄/回购后数量]</p>';
        }
        if (!this.edit_option.ripe_scale) {
          err_msg += '<p>请填写[成熟比例]</p>';
        } else if (!Util.isNumber(this.edit_option.ripe_scale)) {
          err_msg += '<p>请以小数填写[成熟比例], 如: 0.5, 0.75等</p>';
        }
        if (!this.edit_option.ripe_count) {
          err_msg += '<p>请填写[成熟数量]</p>';
        } else if (!Util.isNumber(this.edit_option.ripe_count)) {
          err_msg += '<p>请填写正确的[成熟数量]</p>';
        }
        if (!this.edit_option.buying_price) {
          err_msg += '<p>请填写[行权价格]</p>';
        } else if (!Util.isNumber(this.edit_option.buying_price)) {
          err_msg += '<p>请填写正确的[行权价格]</p>';
        }
        if (!this.edit_option.selling_price) {
          err_msg += '<p>请填写[公司估值]</p>';
        } else if (!Util.isNumber(this.edit_option.selling_price)) {
          err_msg += '<p>请填写正确的[公司估值]</p>';
        }
        if (!this.edit_option.option_total_price) {
          err_msg += '<p>请填写[期权总价值]</p>';
        } else if (!Util.isNumber(this.edit_option.option_total_price)) {
          err_msg += '<p>请填写正确的[期权总价值]</p>';
        }
        if (!this.edit_option.ripe_total_price) {
          err_msg += '<p>请填写[已成熟总价值]</p>';
        } else if (!Util.isNumber(this.edit_option.ripe_total_price)) {
          err_msg += '<p>请填写正确的[已成熟总价值]</p>';
        }
        if (err_msg) {
          this.$Modal.error({
            title: '错误提示',
            content: err_msg
          });
          this.edit_option_config.loading = false;
          setTimeout(() => {
            this.edit_option_config.loading = true;
          }, 500);
          return false;
        }
        return true;
      },
      editOptionOk() {
        console.log(this.edit_option);
        if (this.checkValid()) {
          Util.ajax.post(Util.api.update_customer_option, this.edit_option).then((response) => {
            return response.data;
          }).then((data) => {
            if (data.code === 1) {
              Util.insertOrUpdateArrayItem(this.options, data.option, true);
              this.edit_option_config.modal = false;
            } else {
              this.edit_option_config.loading = false;
              setTimeout(() => {
                this.edit_option_config.loading = true;
              }, 500);
              this.$Modal.error({
                title: '保存出错',
                content: data.msg
              })
            }
          }).catch((e) => {
            this.edit_option_config.loading = false;
            setTimeout(() => {
              this.edit_option_config.loading = true;
            }, 500);
            this.$Modal.error({
              title: '保存出错',
              content: e.message
            })
          });
        }
      },
      isDeleting(option) {
        return option.id === this.deleting_option_id;
      },
      delOption(option, index) {
        this.deleting_option_id = option.id;
        Util.ajax.post(Util.api.delete_customer_option, option).then((response) => {
          return response.data;
        }).then((data) => {
          this.deleting_option_id = 0;
          if (data.code === 1) {
            this.options.splice(index, 1);
          } else {
            this.$Modal.error({
              title: '保存出错',
              content: data.msg
            })
          }
        }).catch((e) => {
          this.deleting_option_id = 0;
          this.$Modal.error({
            title: '保存出错',
            content: e.message
          })
        });
      },
      getOptionOrders() {
        this.order_loading = true;
        Util.ajax.get(Util.api.get_option_orders, {
          params: this.order_params
        }).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.code === 1) {
            this.orders = [];
            data.orders.forEach((order) => {
              this.orders.push(order);
            });
          } else {
            this.$Modal.error({
              title: '获取期权订单出错',
              content: data.msg
            })
          }
        }).catch((e) => {
          this.deleting_option_id = 0;
          this.$Modal.error({
            title: '获取期权订单出错',
            content: e.message
          })
        }).finally(() => {
          this.order_loading = false;
        });
      },
      setExportYear(year) {
        this.order_params.year = year;
      },
      exportOrders() {
        if (!this.order_params.year) {
          this.$Modal.error({title: '提示', content: '请选择年份'});
          return;
        }
        window.open(Util.api.export_option_orders + '?' + Util.urlEncode(this.order_params), '_blank');
      }
    }
  }
</script>
